import LocalizedStrings from 'localized-strings';

export const locales = new LocalizedStrings({
  en: {
    accounting: {
      main: 'Accounting',
      routes: {
        estimation: 'Social contributions',
        exports: 'Accounting export',
      },
    },
    banking: {
      bank: 'Bank',
      bankAccounts: 'Accounts',
      proBank: 'Business account',
      transactions: 'Transactions',
    },
    bankTransfers: 'Bank transfers',
    catalog: 'Item catalog',
    categoryTitles: {
      bank: 'Banking',
      management: 'Management',
      plus: 'Plus',
    },
    clients: 'Clients',
    collections: 'Collections',
    creditCard: 'Cards',
    dashboard: {
      main: 'Finances tracking',
      routes: {
        overview: 'Dashboards',
        treasury: 'Cash flow',
      },
    },
    expenseClaims: 'Expense claims',
    help: 'Help center',
    insurances: 'Insurance',
    integrations: 'Integrations',
    invoices: 'Invoices',
    newPsp: 'New PSP',
    offers: 'Offers',
    payments: 'Payments',
    quotes: 'Quotes',
    team: {
      main: 'My team',
      routes: {
        members: 'Team members',
        requests: 'Requests {count}',
      },
    },
    toolbox: 'Partners',
    upgradeLabel: 'Change your offer',
    work: 'Invoicing',
  },
  fr: {
    accounting: {
      main: 'Comptabilité',
      routes: {
        estimation: 'Cotisations sociales',
        exports: 'Export comptable',
      },
    },
    banking: {
      bank: 'Banque',
      bankAccounts: 'Comptes',
      proBank: 'Compte pro',
      transactions: 'Transactions',
    },
    bankTransfers: 'Virements',
    catalog: 'Catalogue d’articles',
    categoryTitles: {
      bank: 'Banque',
      management: 'Gestion',
      plus: 'Plus',
    },
    clients: 'Client·es',
    collections: 'Collections',
    creditCard: 'Cartes bancaires',
    dashboard: {
      main: 'Suivi des finances',
      routes: {
        overview: 'Tableaux de bord',
        treasury: 'Suivi de trésorerie',
      },
    },
    expenseClaims: 'Notes de frais',
    help: 'Centre d’aide',
    insurances: 'Assurances',
    integrations: 'Intégrations',
    invoices: 'Factures',
    newPsp: 'Nouveau PSP',
    offers: 'Offres',
    payments: 'Paiements',
    quotes: 'Devis',
    team: {
      main: 'Mon équipe',
      routes: {
        members: 'Membres de l’équipe',
        requests: 'Demandes {count}',
      },
    },
    toolbox: 'Partenaires',
    upgradeLabel: 'Changer d’offre',
    work: 'Facturation',
  },
} as const);
